<template>
    <SettingsPage title="Email Settings">
        <template #settingsForms>
            <SettingsForm
                :settingsLoading="settingsLoading"
                form="newUserRegistration"
            >
                <template #title>
                    New User Registration
                </template>
                <template #form>
                    <form
                        action=""
                        method="POST"
                        id="newUserRegistration"
                        @submit.prevent="saveNewUserRegistration"
                    >
                        <v-text-field
                            label="Subject"
                            name="newUserRegistrationSubject"
                            v-model="settings.newUserRegistrationSubject"
                            outlined
                        />
                        <v-text-field
                            label="Heading"
                            name="newUserRegistrationHeading"
                            v-model="settings.newUserRegistrationHeading"
                            outlined
                        />
                        <v-textarea
                            label="Body"
                            name="newUserRegistrationBodyCopy"
                            v-model="settings.newUserRegistrationBodyCopy"
                            outlined
                        />
                    </form>
                </template>
            </SettingsForm>

            <SettingsForm
                :settingsLoading="settingsLoading"
                form="passwordResetSuccess"
            >
                <template #title>
                    Successful Password Reset
                </template>
                <template #form>
                    <form
                        action=""
                        method="POST"
                        id="passwordResetSuccess"
                        @submit.prevent="saveSuccessfulPasswordReset"
                    >
                        <v-text-field
                            label="Subject"
                            name="successfulPasswordResetSubject"
                            v-model="settings.successfulPasswordResetSubject"
                            outlined
                        />
                        <v-text-field
                            label="Heading"
                            name="successfulPasswordResetHeading"
                            v-model="settings.successfulPasswordResetHeading"
                            outlined
                        />
                        <v-textarea
                            label="Body"
                            name="successfulPasswordResetBodyCopy"
                            v-model="settings.successfulPasswordResetBodyCopy"
                            outlined
                        />
                        <v-text-field
                            label="Support Button Text"
                            name="successfulPasswordResetSupportButtonText"
                            v-model="settings.successfulPasswordResetSupportButtonText"
                            outlined
                        />
                    </form>
                </template>
            </SettingsForm>

            <SettingsForm
                :settingsLoading="settingsLoading"
                form="successfulPasswordChange"
            >
                <template #title>
                    Successful Password Change
                </template>
                <template #form>
                    <form
                        action=""
                        method="POST"
                        id="successfulPasswordChange"
                        @submit.prevent="saveSuccessfulPasswordChange"
                    >
                        <v-text-field
                            label="Subject"
                            name="successfulPasswordChangeSubject"
                            v-model="settings.successfulPasswordChangeSubject"
                            outlined
                        />
                        <v-text-field
                            label="Heading"
                            name="successfulPasswordChangeHeading"
                            v-model="settings.successfulPasswordChangeHeading"
                            outlined
                        />
                        <v-textarea
                            label="Body"
                            name="successfulPasswordChangeBodyCopy"
                            v-model="settings.successfulPasswordChangeBodyCopy"
                            outlined
                        />
                        <v-text-field
                            label="Support Button Text"
                            name="successfulPasswordChangeSupportButtonText"
                            v-model="settings.successfulPasswordChangeSupportButtonText"
                            outlined
                        />
                    </form>
                </template>
            </SettingsForm>

            <SettingsForm
                :settingsLoading="settingsLoading"
                form="successfulEmailChange"
            >
                <template #title>
                    Successful Email Change
                </template>
                <template #form>
                    <form
                        action=""
                        method="POST"
                        id="successfulEmailChange"
                        @submit.prevent="saveSuccessfulEmailChange"
                    >
                        <v-text-field
                            label="Subject"
                            name="successfulEmailChangeSubject"
                            v-model="settings.successfulEmailChangeSubject"
                            outlined
                        />
                        <v-text-field
                            label="Heading"
                            name="successfulEmailChangeHeading"
                            v-model="settings.successfulEmailChangeHeading"
                            outlined
                        />
                        <v-textarea
                            label="Body"
                            name="successfulEmailChangeBodyCopy"
                            v-model="settings.successfulEmailChangeBodyCopy"
                            outlined
                        />
                        <v-text-field
                            label="Support Button Text"
                            name="successfulEmailChangeSupportButtonText"
                            v-model="settings.successfulEmailChangeSupportButtonText"
                            outlined
                        />
                    </form>
                </template>
            </SettingsForm>

            <SettingsForm
                :settingsLoading="settingsLoading"
                form="userSupportRequest"
            >
                <template #title>
                    Support Request Autoresponder
                </template>
                <template #form>
                    <form
                        action=""
                        method="POST"
                        id="userSupportRequest"
                        @submit.prevent="saveUserSupportRequest"
                    >
                        <v-text-field
                            label="Subject"
                            name="userSupportRequestSubject"
                            v-model="settings.userSupportRequestSubject"
                            outlined
                        />
                        <v-text-field
                            label="Heading"
                            name="userSupportRequestHeading"
                            v-model="settings.userSupportRequestHeading"
                            outlined
                        />
                        <v-textarea
                            label="Body"
                            name="userSupportRequestBodyCopy"
                            v-model="settings.userSupportRequestBodyCopy"
                            outlined
                        />
                    </form>
                </template>
            </SettingsForm>
        </template>
    </SettingsPage>
</template>

<script>
import settingsMixin from '@/views/Admin/Config/Settings/Common/settingsMixin';
import SettingsPage from '@/views/Admin/Config/Settings/Common/SettingsPage';
import SettingsForm from '@/views/Admin/Config/Settings/Common/SettingsForm';

export default {
    components: { SettingsForm, SettingsPage },
    mixins: [settingsMixin],
    props: [],

    data() {
        return {
            settingPage: 'email',
            settingName: 'settingEmail'
        };
    },

    methods: {
        saveNewUserRegistration() {
            const settings = {
                newUserRegistrationSubject: this.settings.newUserRegistrationSubject,
                newUserRegistrationHeading: this.settings.newUserRegistrationHeading,
                newUserRegistrationBodyCopy: this.settings.newUserRegistrationBodyCopy
            };

            this.saveSettings(this.settingPage, this.setPostData(`${this.settingName}NewUserRegistration`, settings));
        },

        saveSuccessfulPasswordReset() {
            const settings = {
                successfulPasswordResetSubject: this.settings.successfulPasswordResetSubject,
                successfulPasswordResetHeading: this.settings.successfulPasswordResetHeading,
                successfulPasswordResetBodyCopy: this.settings.successfulPasswordResetBodyCopy,
                successfulPasswordResetSupportButtonText: this.settings.successfulPasswordResetSupportButtonText
            };

            this.saveSettings(this.settingPage, this.setPostData(`${this.settingName}SuccessfulPasswordReset`, settings));
        },

        saveSuccessfulPasswordChange() {
            const settings = {
                successfulPasswordChangeSubject: this.settings.successfulPasswordChangeSubject,
                successfulPasswordChangeHeading: this.settings.successfulPasswordChangeHeading,
                successfulPasswordChangeBodyCopy: this.settings.successfulPasswordChangeBodyCopy,
                successfulPasswordChangeSupportButtonText: this.settings.successfulPasswordChangeSupportButtonText
            };

            this.saveSettings(this.settingPage, this.setPostData(`${this.settingName}SuccessfulPasswordChange`, settings));
        },

        saveSuccessfulEmailChange() {
            const settings = {
                successfulEmailChangeSubject: this.settings.successfulEmailChangeSubject,
                successfulEmailChangeHeading: this.settings.successfulEmailChangeHeading,
                successfulEmailChangeBodyCopy: this.settings.successfulEmailChangeBodyCopy,
                successfulEmailChangeSupportButtonText: this.settings.successfulEmailChangeSupportButtonText
            };

            this.saveSettings(this.settingPage, this.setPostData(`${this.settingName}SuccessfulEmailChange`, settings));
        },

        saveUserSupportRequest() {
            const settings = {
                userSupportRequestSubject: this.settings.userSupportRequestSubject,
                userSupportRequestHeading: this.settings.userSupportRequestHeading,
                userSupportRequestBodyCopy: this.settings.userSupportRequestBodyCopy
            };

            this.saveSettings(this.settingPage, this.setPostData(`${this.settingName}UserSupportRequest`, settings));
        }
    }
};
</script>
